module.exports = "<article>\r\n\t<section ng-bind-html=\"page\"> </section>\r\n\t<!-- test -->\r\n</article>";